// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_gUW","cls2":"SearchOnboardingOverhaul-cls2_Z4k SearchOnboardingOverhaul-cls1_gUW"};